import { Route, Routes } from "react-router-dom";
import ConciliacaoAuttarConsultaScreen from "./ConciliacaoAuttarConsultaScreen";
import TelaPermissao from "@/Components/Base/Permissao/TelaPermissao";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";
import { Tabs } from "antd";

export default function ConciliacaoAuttarScreen() {
    return <ConciliacaoAuttarConsultaScreen codTrabalhoTipo={EnumTrabalhoTipo.ConciliacaoGetNet} />;
}